var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "c--social_social-login display-flex align-content-center justify-content-center tw-gap-4 sm:tw-gap-7.5"
  }, _vm._l(_vm.buttons, function (item, index) {
    return _c('a', {
      key: `social-button-${index}`,
      class: `display-flex justify-content-center align-items-center box-rounded shadowed square-44 tw-flex-shrink-0 cursor-pointer social-login--${item.name}`,
      attrs: {
        "data-testid": `${item.name}-social`
      },
      on: {
        "click": function ($event) {
          $event.preventDefault();
          return _vm.onClick(item.name);
        }
      }
    }, [_c('img', {
      staticClass: "square-22",
      attrs: {
        "src": `/assets/images/icons/${item.name}-icon1.svg`,
        "width": "22",
        "height": "22",
        "loading": "eager",
        "alt": item.name
      }
    })]);
  }), 0);

}
var staticRenderFns = []

export { render, staticRenderFns }